import ReactHtmlParser, { convertNodeToElement } from 'react-html-parser'
import * as R from 'ramda'
import { isValidLink } from 'commons/website'

const transform = (node, index) => {
  if (R.allPass([R.propEq('type', 'tag'), R.propEq('name', 'a')])(node)) {
    node.attribs.target = '_blank'
    node.attribs.class = 'rich-text-link'
    node.attribs.href = R.compose(
      R.unless(isValidLink, R.compose(R.join(''), R.prepend('//'))),
      R.path(['attribs', 'href']),
    )(node)
    return convertNodeToElement(node, index, transform)
  }
}

export default function RichTextDisplay({ text }) {
  return ReactHtmlParser(text, {
    transform,
  })
}
